'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.template = undefined;

exports.default = function (string) {
  var decoded = entities.decode(string);
  return (0, _reactHtmlParser2.default)(decoded);
};

var _reactHtmlParser = require('react-html-parser');

var _reactHtmlParser2 = _interopRequireDefault(_reactHtmlParser);

var _htmlEntities = require('html-entities');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var entities = new _htmlEntities.Html5Entities();

exports.template = _template2.default;